/** Tiny tracker for public sites. Fires `page_view` once on mount.
 *  Sticky session_id per tab; UTM/referrer auto-detected from window.location + document.referrer. */
import { useEffect } from "react";
import { api } from "@/lib/api";

function getOrCreateSessionId() {
  try {
    let id = sessionStorage.getItem("iti.tracker_sid");
    if (!id) {
      id = `s_${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`;
      sessionStorage.setItem("iti.tracker_sid", id);
    }
    return id;
  } catch { return ""; }
}

export function useTrackPageView(slug, pagePath) {
  useEffect(() => {
    if (!slug) return;
    const params = new URLSearchParams(window.location.search);
    api.post("/analytics/track", {
      slug,
      event: "page_view",
      page: pagePath || window.location.pathname,
      referrer: document.referrer || "",
      session_id: getOrCreateSessionId(),
      utm_medium: params.get("utm_medium") || "",
      utm_source: params.get("utm_source") || "",
    }).catch(() => {});
  }, [slug, pagePath]);
}

export function trackEvent(slug, event, extra = {}) {
  return api.post("/analytics/track", {
    slug, event,
    session_id: getOrCreateSessionId(),
    page: window.location.pathname,
    referrer: document.referrer || "",
    ...extra,
  }).catch(() => {});
}
